import DOMPurify from 'dompurify';

/**
 * Sanitizes text content for safe rendering
 * Removes potentially dangerous HTML/script content while preserving safe text
 * @param {string} text - The text to sanitize
 * @returns {string} Sanitized text safe for rendering
 */
export function sanitizeTextForRender(text) {
  if (!text) {
    return '';
  }

  // If it's already plain text (no HTML), return as is
  if (typeof text === 'string' && !/<[^>]*>/.test(text)) {
    return text;
  }

  // Use DOMPurify to sanitize HTML content
  return DOMPurify.sanitize(text, {
    ALLOWED_TAGS: [
      'p',
      'br',
      'b',
      'i',
      'em',
      'strong',
      'a',
      'ul',
      'ol',
      'li',
      'blockquote',
      'code',
      'pre',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'span',
      'div',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style'],
    ALLOW_DATA_ATTR: false,
  });
}

export default sanitizeTextForRender;
